import { useI18nContext } from "@hopper-b2b/i18n";
import { HotelSortOptionEnum } from "@overrides/types";

export interface HotelListSortOptions {
  // A unique identifier for the sort option
  value: HotelSortOptionEnum;
  // A user-facing string that describes this sort option
  label: string;
  // A shorter user-facing string used when the option is selected
  shortLabel: string;
}

export const useHotelListSortOptions = (): HotelListSortOptions[] => {
  const { t } = useI18nContext();
  return [
    {
      value: HotelSortOptionEnum.Recommended,
      label: t("core-hotels.availabilityPage.sort.option.recommended"),
      shortLabel: t(
        "core-hotels.availabilityPage.sort.option.recommendedShortened"
      ),
    },
    {
      value: HotelSortOptionEnum.Price,
      label: t("core-hotels.availabilityPage.sort.option.price"),
      shortLabel: t("core-hotels.availabilityPage.sort.option.priceShortened"),
    },
    {
      value: HotelSortOptionEnum.StarRating,
      label: t("core-hotels.availabilityPage.sort.option.starRating"),
      shortLabel: t(
        "core-hotels.availabilityPage.sort.option.starRatingShortened"
      ),
    },
    {
      value: HotelSortOptionEnum.UserRating,
      label: t("core-hotels.availabilityPage.sort.option.userRating"),
      shortLabel: t(
        "core-hotels.availabilityPage.sort.option.userRatingShortened"
      ),
    },
  ];
};
